import { render, staticRenderFns } from "./forecasts-add.vue?vue&type=template&id=d1b917a2&scoped=true&%23default=true"
import script from "./forecasts-add.vue?vue&type=script&lang=js"
export * from "./forecasts-add.vue?vue&type=script&lang=js"
import style0 from "./forecasts-add.vue?vue&type=style&index=0&id=d1b917a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b917a2",
  null
  
)

export default component.exports